var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('EditorExistingComments'),_c('EditorNewComment',{attrs:{"assignment":_vm.assignment}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }